import baseURL from "../common/axios";
class Commonservices {
  insert(objinsert) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("UnitConversion/Create", objinsert);
  }
  getdata() {
    debugger;
    return baseURL.httpMSInventoryUrl.get("UnitConversion/List");
  }
  Edit(EditId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get("UnitConversion/Get?id=" + EditId + "");
  }
  Delete(DelID) {
    debugger;
    return baseURL.httpMSInventoryUrl.delete("UnitConversion/Delete?id=" + DelID);
  }
  //Active
  active(DelID, Status) {
    debugger;
    return baseURL.httpMSInventoryUrl.put(
      "UnitConversion/Active?id=" + DelID + "&Status=" + Status + ""
    );
  }
  Update(objupdate) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("UnitConversion/Update", objupdate);
  }
}
export default new Commonservices();
